const initiateVideoSTL = function (event) {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const windowWidth = window.innerWidth;
  const videos = document.querySelectorAll("video.video-autoplay");
  let isUserInteracted = false;
  let videoPlayPromises = new Map();

  const videoColums = document.querySelectorAll(
    ".shop-the-look .stl-video-column"
  );

  // PRODUCT POP UP AND SHARE BUTTON LOGIC

  videoColums.forEach((column) => {
    const productVideoButtons = column.querySelectorAll(
      ".produse-wrapper .stl-produs"
    );
    const productVideoPopups = column.querySelectorAll(
      ".galerie-produs .produs-wrapper"
    );
    const videoOverlay = column.querySelector(".stl-video-overlay");

    let activeButton = null;
    let activePopup = null;

    productVideoButtons.forEach((button) => {
      button.onclick = () => {
        const clickedPopup = Array.from(productVideoPopups).find(
          (popup) => button.dataset.id === popup.dataset.id
        );

        if (activeButton !== button && activeButton !== null) {
          activeButton.classList.remove("produs-activ");
          activePopup.classList.remove("show-pop-up");
          videoOverlay.classList.remove("stl-showOverlay");
        }

        button.classList.toggle("produs-activ");
        clickedPopup.classList.toggle("show-pop-up");
        videoOverlay.classList.toggle("stl-showOverlay");

        activeButton = button.classList.contains("produs-activ")
          ? button
          : null;
        activePopup = clickedPopup.classList.contains("show-pop-up")
          ? clickedPopup
          : null;
      };
    });

    videoOverlay.onclick = () => {
      const videoProductShare = column.querySelector(
        ".share-produs-wrapper.show"
      );
      activeButton.classList.remove("produs-activ");
      activePopup.classList.remove("show-pop-up");
      videoOverlay.classList.remove("stl-showOverlay");
      if (videoProductShare.classList.contains("show")) {
        videoProductShare.classList.remove("show");
      } else {
        return;
      }
    };
  });

  // AUTOPLAY VIDEO ON MOBILE WHEN IN VIEWPORT

    function autoplayVisibleVideos() {
    const videos = document.querySelectorAll("video.video-autoplay");
    for (let i = 0; i < videos.length; i++) {
      const videoBtns = videos[i].nextElementSibling;
      const videoRect = videos[i].getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const videoHeight = videoRect.height;
      const visibleHeight =
        Math.min(videoHeight, windowHeight + videoRect.top, videoRect.bottom) -
        Math.max(0, videoRect.top);
      const visibilityRatio = visibleHeight / videoHeight;
      const isPartiallyVisible = visibilityRatio >= 0.5;
      if (windowWidth <= 991 && isPartiallyVisible) {
        if (!isVideoPlaying(videos[i])) {
          videoPlayPromises.set(videos[i], videos[i].play());
        }
        if (videoBtns) {
          videoBtns.classList.add("pause");
        }
      } else if (windowWidth <= 767 && isPartiallyVisible) {
        if (!isVideoPlaying(videos[i])) {
          videoPlayPromises.set(videos[i], videos[i].play());
        }
        if (videoBtns) {
          videoBtns.classList.add("pause");
        }
      } else {
        videoPlayPromises.get(videos[i])?.then(() => {
          videos[i].pause();
          if (videoBtns) {
            videoBtns.classList.remove("pause");
          }
        });
      }
    }
  }

  // VIDEO PLAY FUNCTION AND BUTTONS LOGIC ON TABLET AND MOBILE

  function isVideoPlaying(video) {
    return !!(
      video.currentTime > 0 &&
      !video.paused &&
      !video.ended &&
      video.readyState > 2
    );
  }

  function videoPlay() {
    let currentVideo;
    const newVideos = $("#main").find("video.video-autoplay");
    newVideos.each(function () {
      const video = this;
      video.muted = true;
      const videoBtns = $(video).next();
      const videoSoundBtns = videoBtns.next();

      videoSoundBtns.find(".video-muted").on("click", () => {
        if (currentVideo && currentVideo !== video) {
          currentVideo.muted = true;
          const currentVideoBtns = $(currentVideo).next();
          const currentVideoSoundBtns = currentVideoBtns.next();
          currentVideoSoundBtns.removeClass("muted");
        }
        if (isVideoPlaying(video)) {
          video.muted = false;
          currentVideo = video;
          videoSoundBtns.addClass("muted");
        }
      });

      videoSoundBtns.find(".video-unmuted").on("click", () => {
        video.muted = true;
        currentVideo = video;
        videoSoundBtns.removeClass("muted");
      });

      if (windowWidth <= 991 || isSafari) {
        videoBtns.addClass("safari");

        videoBtns.find(".video-play").on("click", () => {
          if (currentVideo && currentVideo !== video) {
            videoPlayPromises.get(currentVideo)?.then(() => {
              currentVideo.pause();
              const currentVideoBtns = $(currentVideo).next();
              currentVideoBtns.removeClass("pause");
              currentVideo.muted = true;
              currentVideoSoundBtns.removeClass("muted");
            });
          }
          if (!isVideoPlaying(video)) {
            videoPlayPromises.set(video, video.play());
            currentVideo = video;
            videoBtns.addClass("pause");
          }
        });

        videoBtns.find(".video-pause").on("click", () => {
          videoPlayPromises.get(video)?.then(() => {
            video.pause();
            currentVideo = undefined;
            videoBtns.removeClass("pause");
            video.muted = true;
            videoSoundBtns.removeClass("muted");
          });
        });

        // Remove the click event handlers on the video element
        $(video).off("click");

        $(video).on("click", () => {
          if (currentVideo && currentVideo !== video) {
            videoPlayPromises.get(currentVideo)?.then(() => {
              currentVideo.pause();
              const currentVideoBtns = $(currentVideo).next();
              const currentVideoSoundBtns = currentVideoBtns.next();
              currentVideoBtns.removeClass("pause");
              currentVideo.muted = true;
              currentVideoSoundBtns.removeClass("muted");
            });
          }
          if (video.paused) {
            if (!isVideoPlaying(video)) {
              videoPlayPromises.set(video, video.play());
              currentVideo = video;
              videoBtns.addClass("pause");
            }
          } else {
            videoPlayPromises.get(video)?.then(() => {
              video.pause();
              currentVideo = null;
              videoBtns.removeClass("pause");
              video.muted = true;
              videoSoundBtns.removeClass("muted");
            });
          }
        });
      } else {
        $(video).on("mouseenter", () => {
          if (!isVideoPlaying(video)) {
            videoPlayPromises.set(video, video.play());
              video.muted = false;
              videoSoundBtns.addClass("muted");
          }
        });

        $(video).on("mouseleave", () => {
            videoPlayPromises.get(video)?.then(() => {
              video.pause();
              videoSoundBtns.removeClass("muted");
            });
        });
      }
    });
  }

  if (windowWidth <= 767) {
    window.addEventListener("scroll", autoplayVisibleVideos);
  }
  videoPlay();
};

document.addEventListener("DOMContentLoaded", () => {
  initiateVideoSTL();
});
